// ─── src/api/stats.ts ─────────────────────────────────────────────────────────

import { apiClient } from "./registration";
import type { RegistrationStatsResponse, MentorStatsResponse } from "../types/stats";

export const getRegistrationStats = async (
  city?: string,
): Promise<RegistrationStatsResponse> => {
  const { data } = await apiClient.get<RegistrationStatsResponse>(
    "/registrations/stats",
    { params: city ? { city } : {} },
  );
  return data;
};

export const getMentorStats = async (): Promise<MentorStatsResponse> => {
  const { data } = await apiClient.get<MentorStatsResponse>("/mentors/stats");
  return data;
};
